module.exports = __webpack_public_path__ + "archivist_lamambert.png?dcc7276d7cc16155b544f242b4cd0b35";


//////////////////
// WEBPACK FOOTER
// ./src/img/profili/archivist_lamambert.png
// module id = 391
// module chunks = 0